export default "__VITE_ASSET__CoXOspO___"